import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { UserList, RoleList, UserDetail } from './types'

export const selectUserList = (state: RootState): UserList => state.manangeUserReducer.userList

export const selectRoleList = (state: RootState): RoleList => state.manangeUserReducer.roleList

export const selectUserDetail = (state: RootState): UserDetail => state.manangeUserReducer.userDetail

export const selectActionEvent = (state: RootState): Event => state.manangeUserReducer.actionEvent
